export default function RefundPolicy() {
  return (
    <main className="container py-5">
      <h1>Refund Policy</h1>
      <p>Last updated: August 2, 2025</p>

      <h3>Overview</h3>
      <p>
        We strive to ensure customer satisfaction. If {"you're not entirely satisfied with your purchase, we're"} here to help.
      </p>

      <h3>Eligibility for Refunds</h3>
      <ul>
        <li>Items must be unused and in the same condition as received.</li>
        <li>Request must be made within 7 days of purchase.</li>
        <li>Proof of purchase is required.</li>
      </ul>

      <h3>Non-Refundable Items</h3>
      <ul>
        <li>Downloadable digital products</li>
        <li>Gift cards</li>
        <li>Customized or personalized items</li>
      </ul>

      <h3>How to Request a Refund</h3>
      <p>
        To start a refund request, please email us at <a href="mailto:support@example.com">support@example.com</a> with your order number and reason for the refund.
      </p>

      <h3>Processing</h3>
      <p>
        Once your request is received and approved, we will initiate a refund to your original method of payment within 5-7 business days.
      </p>

      <h3>Need Help?</h3>
      <p>
        Contact us at <a href="mailto:support@example.com">support@example.com</a> for questions related to refunds.
      </p>
    </main>
  );
}
